import {
  Button,
  Card,
  ChakraProvider,
  Container,
  Grid,
  HStack,
  Tab,
  TabList,
  Tabs,
  Text,
  useMediaQuery,
} from "@chakra-ui/react";
import { useEffect, useRef, useState } from "react";
import { Menu } from "react-feather";
import { useLocation, useNavigate } from "react-router-dom";
import BankManagement from "./bankManagement";
import { MyDetails } from "./myDetails";
import { Password } from "./password";
import theme from "../../theme";
import ClientDashboardLayout from "../dashboard/dashboardLayout";
import { useCurrentProfile } from "../../ContextWrapper";

export const ProfileSettings = ({setProfile = null}) => {
  const { profile } = useCurrentProfile();
  const customers = profile.customers;

  const [activeCustomer, setActiveCustomer] = useState(() => {
    const stored = sessionStorage.getItem("selectedCustomerId");
    return customers.find((c) => c.id.toString() === stored) || customers[0];
  });

  useEffect(() => {
    const handleSelectedChange = () => {
      const stored = sessionStorage.getItem("selectedCustomerId");

      if (!stored) return;

      const found = customers.find((c) => c.id.toString() === stored);

      if (found) {
        setActiveCustomer(found);
      }
    };

    window.addEventListener("selectedCustomerId-changed", handleSelectedChange);

    return () => {
      window.removeEventListener(
        "selectedCustomerId-changed",
        handleSelectedChange
      );
    };
  }, [customers]);

  useEffect(() => {
    if (!customers.length) return;

    const stored = sessionStorage.getItem("selectedCustomerId");

    if (stored) {
      const found = customers.find((c) => c.id.toString() === stored);
      if (found) {
        setActiveCustomer(found);
        return;
      }
    }

    setActiveCustomer(customers[0]);
  }, [customers]);

  const customer = activeCustomer;
  const customerId = activeCustomer.id;

  const navigate = useNavigate();
  const location = useLocation();
  const navigateRef = useRef(navigate);

  const tabFromUrl = location.pathname.includes("password")
    ? "password"
    : location.pathname.includes("bank-management") &&
      customer?.customer_type !== "group" &&
      !customer?.is_demo
    ? "bank-management"
    : "myDetails";

  const [tab, setTab] = useState(tabFromUrl);

  const [isMobile] = useMediaQuery("(max-width: 1280px)");

  useEffect(() => {
    const newTab = location.pathname.includes("password")
      ? "password"
      : location.pathname.includes("bank-management") &&
        customer?.customer_type !== "group" &&
        !customer?.is_demo
      ? "bank-management"
      : "myDetails";
    setTab(newTab);
  }, [location.pathname, customer?.customer_type, customer?.is_demo]);

  const showBankTab = customer?.customer_type !== "group" && !customer?.is_demo;

  const tabIndex =
    tab === "myDetails" ? 0 : tab === "password" ? 1 : showBankTab ? 2 : 0;

  useEffect(() => {
    // If /settings/profile/bank-management but bank tab should not show
    if (location.pathname.includes("bank-management") && !showBankTab) {
      navigateRef.current("/settings/profile", { replace: true });
      setTab("myDetails");
    }
  }, [location.pathname, showBankTab]);

  return (
    <ClientDashboardLayout>
      <ChakraProvider theme={theme}>
        <Container
          maxW="100%"
          bg="#F4F4F2"
          minH={"100vh"}
          p="0px"
          overflowX={"hidden"}
          position={"relative"}
        >
          {isMobile ? (
            <Card
              position="fixed"
              zIndex={302}
              borderRadius={0}
              h="72px"
              borderBottom="1px solid #e0e0e0"
              width="100%"
            >
              <HStack
                justifyContent="space-between"
                alignItems="center"
                h={"100%"}
                w="100%"
                px={4}
              >
                <Button
                  bg="white"
                  _hover={{ color: "white" }}
                  _active={{ color: "white" }}
                  w="50px"
                  h="50px"
                  p={2}
                  onClick={() => {
                    window.dispatchEvent(new Event("sidebar:expand"));
                  }}
                >
                  <Menu
                    style={{ width: "50px", height: "100%" }}
                    color="black"
                  />
                </Button>
              </HStack>
            </Card>
          ) : (
            <></>
          )}
          <>
            <Card
              position={"fixed"}
              zIndex={301}
              borderRadius={0}
              mt={isMobile ? "72px" : "0px"}
              h={isMobile ? "50px" : "72px"}
              borderBottom="1px solid #e0e0e0"
              width={isMobile ? "100%" : "100%"}
              marginBottom={100}
            >
              <Tabs index={tabIndex}>
                {!isMobile ? (
                  <Grid
                    templateColumns="1fr 2fr 9fr"
                    width="100%"
                    alignItems="center"
                    p="0px 20px"
                    h={isMobile ? "50px" : "72px"}
                  >
                    <TabList
                      display="flex"
                      alignItems="center"
                      height={isMobile ? "50px" : "73px"}
                    >
                      <Tab
                        _focus={{
                          outline: "none",
                          border: "none",
                          boxShadow: "none",
                        }}
                        _selected={{
                          borderBottom: "3px solid #536DEC",
                          color: "#536DEC",
                        }}
                        _active={{ background: "none" }}
                        cursor="pointer"
                        onClick={() => {
                          navigate("/settings/profile");
                        }}
                        width="90px"
                        height="73px"
                        p="0"
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                      >
                        <Text fontWeight="400" fontSize="16px">
                          Profile
                        </Text>
                      </Tab>
                      <Tab
                        _focus={{
                          outline: "none",
                          border: "none",
                          boxShadow: "none",
                        }}
                        _selected={{
                          borderBottom: "3px solid #536DEC",
                          color: "#536DEC",
                        }}
                        _active={{ background: "none" }}
                        cursor="pointer"
                        onClick={() => {
                          navigate("/settings/password");
                        }}
                        width="90px"
                        height="73px"
                        p="0"
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                      >
                        <Text fontWeight="400" fontSize="16px">
                          Password
                        </Text>
                      </Tab>
                      {showBankTab && (
                        <Tab
                          _focus={{
                            outline: "none",
                            border: "none",
                            boxShadow: "none",
                          }}
                          _selected={{
                            borderBottom: "3px solid #536DEC",
                            color: "#536DEC",
                          }}
                          _active={{ background: "none" }}
                          cursor="pointer"
                          onClick={() => navigate("/settings/bank-management")}
                          width="170px"
                          height="73px"
                          p="0"
                          display="flex"
                          alignItems="center"
                          justifyContent="center"
                        >
                          <Text fontWeight="400" fontSize="16px">
                            Plaid Management
                          </Text>
                        </Tab>
                      )}
                    </TabList>
                  </Grid>
                ) : (
                  <HStack width="100%" align="center" justify="flex-start">
                    <TabList
                      display="flex"
                      justifyContent="flex-start"
                      paddingLeft={2}
                      paddingRight={2}
                      w="100%"
                    >
                      <Tab
                        _focus={{
                          outline: "none",
                          border: "none",
                          boxShadow: "none",
                        }}
                        _selected={{
                          borderBottom: "3px solid #536DEC",
                          color: "#536DEC",
                        }}
                        _active={{ background: "none" }}
                        cursor="pointer"
                        onClick={() => {
                          navigate("/settings/profile");
                        }}
                        h="50px"
                        p="2px 4px"
                        whiteSpace="nowrap" // Prevents text from wrapping
                      >
                        <Text
                          fontWeight="400"
                          fontSize="16px"
                          textAlign="center"
                        >
                          Profile
                        </Text>
                      </Tab>
                      <Tab
                        _focus={{
                          outline: "none",
                          border: "none",
                          boxShadow: "none",
                        }}
                        _selected={{
                          borderBottom: "3px solid #536DEC",
                          color: "#536DEC",
                        }}
                        _active={{ background: "none" }}
                        cursor="pointer"
                        onClick={() => {
                          navigate("/settings/password");
                        }}
                        h="50px"
                        p="2px 4px"
                        whiteSpace="nowrap" // Prevents text from wrapping
                      >
                        <Text
                          fontWeight="400"
                          fontSize="16px"
                          textAlign="center"
                        >
                          Password
                        </Text>
                      </Tab>
                      {showBankTab && (
                        <Tab
                          _focus={{
                            outline: "none",
                            border: "none",
                            boxShadow: "none",
                          }}
                          _selected={{
                            borderBottom: "3px solid #536DEC",
                            color: "#536DEC",
                          }}
                          _active={{ background: "none" }}
                          cursor="pointer"
                          onClick={() => navigate("/settings/bank-management")}
                          h="50px"
                          p="2px 4px"
                          whiteSpace="nowrap"
                        >
                          <Text fontWeight="400" fontSize="16px">
                            Plaid Management
                          </Text>
                        </Tab>
                      )}
                    </TabList>
                  </HStack>
                )}
              </Tabs>
            </Card>

            {tab === "myDetails" && <MyDetails />}
            {tab === "password" && <Password />}
            {tab === "bank-management" && (
              <BankManagement
                customer_id={customerId}
                customer={customer}
                setProfile={setProfile}
              />
            )}
          </>
        </Container>
      </ChakraProvider>
    </ClientDashboardLayout>
  );
};
